import {
  defaultColors as colors,
  defaultTheme,
  ThemeProvider,
} from '@zeptonow/zui';
import React from 'react';
import { ModalProvider } from './modal';
import SideDrawerContextProvider from './side-drawer/sideDrawer.provider';
import ToastContextProvider from './toast/toast.provider';
import { createTheme } from '@mui/material/styles';

interface GlobalContextProviderProps {
  children: React.ReactNode;
}

const theme = createTheme(defaultTheme, {
  components: {
    ...defaultTheme.components,
    MuiStepConnector: {
      styleOverrides: {
        root: {
          display: 'none',
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        root: {
          '& .MuiStepLabel-label': {
            '& div': {
              marginTop: '0.5rem',
            },
            '&.Mui-completed': {
              color: colors.gray[700],
            },
            '&.Mui-active': {
              color: colors.primary[700],
            },
          },
          '& .Mui-active': {
            borderTop: `0.25rem solid ${colors.primary[700]}`,
          },
        },
        iconContainer: {
          display: 'none',
        },
        label: {
          borderTop: `0.25rem solid ${colors.gray[200]}`,
        },
      },
    },
    MuiTypography: {
      ...defaultTheme.components?.MuiTypography,
      styleOverrides: {
        ...defaultTheme.components?.MuiTypography?.styleOverrides,
        root: {
          fontFamily: 'Zepto Norms',
        },
      },
    },
    MuiFormHelperText: {
      ...defaultTheme.components?.MuiFormHelperText,
      styleOverrides: {
        ...defaultTheme.components?.MuiFormHelperText?.styleOverrides,
        root: {
          fontFamily: 'Zepto Norms',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontFamily: 'Zepto Norms',
        },
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        labelContainer: {
          fontFamily: 'Zepto Norms',
        },
      },
    },
    MuiSelect: {
      ...defaultTheme.components?.MuiSelect,
      styleOverrides: {
        ...defaultTheme.components?.MuiSelect?.styleOverrides,
        root: {
          fontFamily: 'Zepto Norms',
        },
      },
    },
    MuiTableCell: {
      ...defaultTheme.components?.MuiTableCell,
      styleOverrides: {
        ...defaultTheme.components?.MuiTableCell?.styleOverrides,
        root: {
          fontFamily: 'Zepto Norms',
        },
      },
    },
    MuiPaginationItem: {
      ...defaultTheme.components?.MuiPaginationItem,
      styleOverrides: {
        ...defaultTheme.components?.MuiPaginationItem?.styleOverrides,
        root: {
          fontFamily: 'Zepto Norms',
        },
      },
    },
    MuiOutlinedInput: {
      ...defaultTheme.components?.MuiOutlinedInput,
      styleOverrides: {
        ...defaultTheme.components?.MuiOutlinedInput?.styleOverrides,
        input: {
          fontFamily: 'Zepto Norms',
          padding: 0,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: 'Zepto Norms',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          fontFamily: 'Zepto Norms',
        },
        listbox: {
          fontFamily: 'Zepto Norms',
        },
      },
    },
  },
});

const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({
  children,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <ToastContextProvider>
        <ModalProvider>
          <SideDrawerContextProvider>{children}</SideDrawerContextProvider>
        </ModalProvider>
      </ToastContextProvider>
    </ThemeProvider>
  );
};

export default GlobalContextProvider;
